// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MiniChatContainer_root__NEWfp {
  position: relative;
  z-index: 1201;
  pointer-events: none;
}
.MiniChatContainer_rootMobile__LnWgA {
  z-index: auto;
}
.MiniChatContainer_root__NEWfp > * {
  pointer-events: all;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/MiniChatContainer/MiniChatContainer.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,oBAAA;AACF;AACE;EACE,aAAA;AACJ;AAGE;EACE,mBAAA;AADJ","sourcesContent":[".root {\n  position: relative;\n  z-index: 1201;\n  pointer-events: none;\n\n  &Mobile {\n    z-index: auto;\n    //height: 100% !important;\n  }\n\n  &>* {\n    pointer-events: all;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MiniChatContainer_root__NEWfp`,
	"rootMobile": `MiniChatContainer_rootMobile__LnWgA`
};
export default ___CSS_LOADER_EXPORT___;
